export default __webpack_public_path__ + "static/media/493.42ff1524.gif";